import LocalClientStore from './LocalClientStore';
import {
  LOCAL_STORAGE_TOKEN_KEY,
  LOCAL_STORAGE_REFRESH_TOKEN_KEY,
  LOCAL_STORAGE_RETURN_URL_KEY,
} from '../utils/constants';

class AuthClientStore extends LocalClientStore {
  static getToken() {
    return this.storage.getItem(LOCAL_STORAGE_TOKEN_KEY);
  }

  static setToken(token) {
    this.storage.setItem(LOCAL_STORAGE_TOKEN_KEY, token);
  }

  static removeToken() {
    this.storage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
  }

  static getRefreshToken() {
    return this.storage.getItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY);
  }

  static setRefreshToken(token) {
    this.storage.setItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY, token);
  }

  static removeRefreshToken() {
    this.storage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY);
  }

  static getReturnUrl() {
    return this.storage.getItem(LOCAL_STORAGE_RETURN_URL_KEY);
  }

  static setReturnUrl(url) {
    this.storage.setItem(LOCAL_STORAGE_RETURN_URL_KEY, url);
  }

  static removeReturnUrl() {
    this.storage.removeItem(LOCAL_STORAGE_RETURN_URL_KEY);
  }
}

export default AuthClientStore;
